import {
  Dialog,
  DialogActions as Buttons,
  DialogContent as Text,
  DialogTitle as Title,
  Divider,
  styled,
  Button,
  DialogContent,
} from '@mui/material';

const DialogTitle = styled(Title)({
  fontSize: '24px',
  lineHeight: '32px',
  fontFamily: 'Calibre-R',
  fontWeight: 500,
  padding: '24px ',
});

const DialogText = styled(Text)({
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'Calibre-R',
  fontWeight: 400,
  paddingTop: '24px',
});

const CancelButton = styled(Button)({
  fontSize: '14px',
  lineHeight: '14px',
  fontFamily: 'Calibre-R',
  fontWeight: 500,
  border: '1px solid #919191',
  borderRadius: 0,
  color: '#2c5e53',
  height: '40px',
  padding: '0px 30.5px',
  ':hover': {
    background: 'rgba(44,94,83,0.04)',
  },
});

const SubmitButton = styled(Button)({
  fontSize: '14px',
  lineHeight: '14px',
  fontFamily: 'Calibre-R',
  fontWeight: 500,
  background: '#2c5e53',
  borderRadius: 0,
  color: '#fff',
  height: '40px',
  padding: '0px 30.5px',
  '&:hover': {
    background: '#20463e',
  },
});

const DialogButtons = styled(Buttons)({
  padding: '29px 32px 24px 0px',
});

export const DeleteAllPolygonsPopup = ({ open, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Clear All Boundaries</DialogTitle>

      <Divider />

      <DialogText>
        You're about to delete all custom area boundaries drawn on the map. This action will
        permanently remove your current work and cannot be undone.
      </DialogText>

      <DialogButtons>
        <CancelButton onClick={onCancel}>Cancel</CancelButton>
        <SubmitButton onClick={onConfirm}>Clear Boundaries</SubmitButton>
      </DialogButtons>
    </Dialog>
  );
};
